/**
 * Фронтовые константы для Files-модуля (Phase 1.3, Files UX Refactor 2026-08-06).
 *
 * FILE_MAX_SIZE_MB — единый источник правды для UI-лимита загрузки.
 * Берём из ENV VITE_MAX_UPLOAD_MB (для override в deploy) или 200 по умолчанию
 * (синхронизировано с backend/src/core/config.py FILE_MAX_SIZE_MB).
 *
 * Не дублировать magic-числа в JSX/компонентах. Если нужно поменять лимит —
 * меняем здесь + в backend config + в ENV.md.
 */
export const FILE_MAX_SIZE_MB: number = Number(
  import.meta.env.VITE_MAX_UPLOAD_MB ?? 200,
);

/**
 * TTL сессии (Phase 2.8 / 6.2). Должно совпадать с ACCESS_TOKEN_EXPIRE_DAYS
 * в backend/src/core/security.py (или config.py — где выдаётся JWT).
 */
export const SESSION_TTL_DAYS: number = Number(
  import.meta.env.VITE_SESSION_TTL_DAYS ?? 7,
);

/**
 * TTL polling'а parsing (Phase 2.7 — Cancel + Timeout).
 *
 * Если dataset.status остался в (uploaded|parsing) дольше этого времени —
 * UI перестаёт auto-poll и показывает «Долго обрабатывается» с кнопками
 * Повторить / Обновить статус / Назад. На Refresh — один разовый GET;
 * если опять uploaded/parsing — polling возобновляется и таймер timeout
 * сбрасывается.
 *
 * 60 секунд — баланс:
 *  - Excel/CSV/PDF-DOCX обычно ready за <20s даже на больших файлах.
 *  - 60s — запас для крупных XLSX/PDF в dev-окружении (solo Celery pool).
 *  - Не показывать «worker упал» < 60s — иначе на каждой крупной загрузке
 *    будет паническое сообщение.
 *
 * Меняется через ENV VITE_PARSING_TIMEOUT_MS (на тот случай, если в prod
 * поставим солёный Celery pool и захотим сократить до 45s).
 */
export const PARSING_TIMEOUT_MS: number = Number(
  import.meta.env.VITE_PARSING_TIMEOUT_MS ?? 60_000,
);
